import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";

import { useState } from "react";
import classnames from "classnames";
import ProcedureManage from "./Procedure/procedureManage";
import StepsManage from "./Step/stepsManage";
import StagesManage from "./Stage/stagesManage";
import ImportJsonButton from "./importJsonButton";
import ExportJsonButton from "./exportJsonButton";
import { useParams, useNavigate, useLocation } from "react-router-dom";

function HomeMonoPageWork() {
    const { chapterName: urlChapterName, folderName } = useParams();
    const folderNameSansExt = folderName?.replace(/\.json$/i, "") || "";
    const procedureNameSansVariante =
        folderNameSansExt.replace(/_[A-Za-z]{2,5}(?:-[A-Za-z]{2,5})?$/, "") || folderNameSansExt;
    const chapterName = urlChapterName || folderNameSansExt.split("_")[0];
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        if (location.search.includes("from=variant")) {
            navigate(`/languageManageWork/${chapterName}?from=variant`);
        } else {
            navigate(`/languageManageWork/${chapterName}`);
        }
    };

    // Tab active (1, 2 ou 3)
    const [activeTab, setActiveTab] = useState("1");

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <div className="page-content">
            <h1 className="text-primary text-center">iXiMAKER - WORK</h1>
            <h2 className="text-tertiary mb-2 text-center">
                Édition de la procédure
            </h2>
            <h3 className="text-primary text-center">
                {procedureNameSansVariante}
            </h3>

            {/* <div className="col-md-12 d-flex justify-content-center">
                <p className="col-md-6 border border-primary rounded text-center small p-2">
                    Pour traduire une procédure, <b>exportez</b> son contenu au
                    format JSON.
                    <br />
                    Faites-le traduire par votre IA préférée, puis{" "}
                    <b>importez-le</b>.
                </p>
            </div> */}

            <Container fluid>
                <Row>
                    <Col lg={12}>
                        {/* Boutons */}
                        <div className="col-md-12 mb-3">
                            <div className="d-flex justify-content-center align-items-center gap-4">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={handleGoBack}
                                >
                                    <i className="dripicons-arrow-left align-middle"></i>{" "}
                                    Retour aux variantes
                                </button>

                                <ExportJsonButton type="work" />
                                <ImportJsonButton type="work" />
                            </div>
                        </div>


                        <Card>
                            <CardBody>
                                <p className="card-title-desc">
                                    Sélectionnez une section pour afficher son
                                    contenu ⤵️
                                </p>

                                {/* ===== TABS HORIZONTAUX ===== */}
                                <Nav
                                    tabs
                                    className="justify-content"
                                >
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => toggleTab("1")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            1️⃣ Paramètres
                                        </NavLink>
                                    </NavItem>
 
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "2",
                                            })}
                                            onClick={() => toggleTab("2")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            2️⃣ Étapes
                                        </NavLink>
                                    </NavItem>
 
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "3",
                                            })}
                                            onClick={() => toggleTab("3")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            3️⃣ Procédures
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                {/* ===== CONTENU ===== */}
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <ProcedureManage />
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <StepsManage />
                                    </TabPane>

                                    <TabPane tabId="3">
                                        <StagesManage />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default HomeMonoPageWork;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license